import React from 'react';
import styles from './ConfirmationModal.module.css';
import { FiXCircle, FiAlertCircle } from 'react-icons/fi';

const ConfirmationModal = ({ isOpen, onClose, position, livePrice, onConfirm }) => {
  if (!isOpen || !position) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <div className={styles.titleRow}>
            <FiXCircle className={styles.headerIcon} />
            <h2>Exit Position</h2>
          </div>
          <p>{position.tradeSymbol} • {position.quantity} Qty</p>
        </div>

        <div className={styles.marketInfo}>
          <div className={styles.infoRow}>
            <span>Average Price</span>
            <span>₹{position.openPrice.toFixed(2)}</span>
          </div>
          <div className={styles.infoRow}>
            <span>Market Price (LTP)</span>
            <span className={styles.ltpValue}>₹{livePrice?.toFixed(2) || position.openPrice.toFixed(2)}</span>
          </div>
        </div>

        <div className={styles.warningBox}>
          <FiAlertCircle />
          <p>This will close your position immediately at the best available market price.</p>
        </div>

        <div className={styles.buttonContainer}>
          <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
          <button 
            className={styles.confirmButton} 
            onClick={() => onConfirm(position._id)}
          >
            Confirm Exit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
